<template>
  <v-card flat min-height="100">
    <v-row class="mx-auto fill-height" no-gutters justify="start">
      <v-col cols="12" md="3" align-self="center">
        <v-radio-group v-model="humanEntry.sex" row
                       :label="$vuetify.lang.t(`$vuetify.criticalDataset.${CriticalDatasetLabels.HUMAN}.sex`)"
                       mandatory>
          <v-radio :value="HumanEntrySex.MALE" :disabled="isFilter && !filters.sex">
            <template v-slot:label>
              <v-icon left>{{ maleIcon }}</v-icon>
              {{ $vuetify.lang.t(`$vuetify.criticalDataset.enums.HumanEntrySex.${HumanEntrySex.MALE}`) }}
            </template>
          </v-radio>
          <v-radio :value="HumanEntrySex.FEMALE" :disabled="isFilter && !filters.sex">
            <template v-slot:label>
              <v-icon left>{{ femaleIcon }}</v-icon>
              {{ $vuetify.lang.t(`$vuetify.criticalDataset.enums.HumanEntrySex.${HumanEntrySex.FEMALE}`) }}
            </template>
          </v-radio>
          <v-checkbox v-show="isFilter" slot="prepend" class="mt-n1" dense
                      @change="filterValueChanged($event, 'sex')"
                      hide-details v-model="filters.sex"></v-checkbox>
        </v-radio-group>
      </v-col>

      <v-col cols="12" md="3" class="pr-md-9" align-self="center">
        <div class="d-inline-flex">
          <v-checkbox v-show="isFilter" class="mt-n1 align-center" dense
                      @change="filterValueChanged($event, 'glasses')"
                      hide-details v-model="filters.glasses"></v-checkbox>
          <v-select v-model="humanEntry.glasses" :items="glassesList" :disabled="isFilter && !filters.glasses"
                    :label="$vuetify.lang.t(`$vuetify.criticalDataset.${CriticalDatasetLabels.HUMAN}.glasses`)">
            <template v-slot:selection="data">
              {{ $vuetify.lang.t(`$vuetify.criticalDataset.enums.HumanEntryGlasses.${data.item}`) }}
            </template>
            <template v-slot:item="data">
              {{ $vuetify.lang.t(`$vuetify.criticalDataset.enums.HumanEntryGlasses.${data.item}`) }}
            </template>

          </v-select>
        </div>

      </v-col>

      <v-col cols="12" md="3" class="px-3" align-self="center">
        <div class="d-inline-flex">
          <v-checkbox v-show="isFilter" class="mt-n1 align-end" dense
                      @change="filterValueChanged($event, 'wearingColorBeltSimilar')"
                      hide-details v-model="filters.wearingColorBeltSimilar"></v-checkbox>
          <v-switch
            :label="$vuetify.lang.t(`$vuetify.criticalDataset.${CriticalDatasetLabels.HUMAN}.wearingColorBeltSimilar`)"
            :disabled="isFilter && !filters.wearingColorBeltSimilar"
            v-model="humanEntry.wearingColorBeltSimilar" hide-details>
          </v-switch>
        </div>
      </v-col>

      <!--
      <v-col cols="12" md="2" class="px-5" align-self="center">
        <v-select v-model="humanEntry.wearingType" :items="wearingList"
                  :label="$vuetify.lang.t(`$vuetify.criticalDataset.${CriticalDatasetLabels.HUMAN}.wearingType`)">
          <template v-slot:selection="data">
            {{ $vuetify.lang.t(`$vuetify.criticalDataset.enums.HumanEntryWearingType.${data.item}`) }}
          </template>
          <template v-slot:item="data">
            {{ $vuetify.lang.t(`$vuetify.criticalDataset.enums.HumanEntryWearingType.${data.item}`) }}
          </template>
        </v-select>
      </v-col>

      <v-col cols="12" md="2" align-self="center">
        <v-text-field v-model="humanEntry.wearingTypeComment" :label="$vuetify.lang.t(`$vuetify.criticalDataset.${CriticalDatasetLabels.HUMAN}.wearingTypeComment`)"></v-text-field>
      </v-col>
      -->

      <v-col cols="12" md="3" class="px-2" align-self="center">
        <div class="d-inline-flex">
          <v-checkbox v-show="isFilter" class="mt-n1 align-end" dense
                      @change="filterValueChanged($event, 'hair')"
                      hide-details v-model="filters.hair"></v-checkbox>
          <v-switch
            :label="$vuetify.lang.t(`$vuetify.criticalDataset.${CriticalDatasetLabels.HUMAN}.hair`)"
            :disabled="isFilter && !filters.hair"
            v-model="humanEntry.hair" hide-details>
          </v-switch>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { HumanEntry } from '../../../models/criticalDataset/HumanEntry'
import {
  CriticalDatasetLabels,
  HumanEntryGlasses,
  HumanEntryHair,
  HumanEntrySex,
  HumanEntryWearingType
} from '../../../enum'
import { mdiGenderFemale, mdiGenderMale } from '@mdi/js'
import criticalDatasetMixin from '../../../mixins/criticalDatasetMixin'

export default {
  name: 'criticalDatasetHuman',
  mixins: [criticalDatasetMixin(HumanEntry, 'human')],
  props: {
    humanEntry: HumanEntry
  },
  data: () => ({
    maleIcon: mdiGenderMale,
    femaleIcon: mdiGenderFemale,
    glassesList: Object.values(HumanEntryGlasses),
    wearingList: Object.values(HumanEntryWearingType),
    hairList: Object.values(HumanEntryHair)
  }),
  created () {
    this['HumanEntrySex'] = HumanEntrySex
    this['HumanEntryGlasses'] = HumanEntryGlasses
    this['CriticalDatasetLabels'] = CriticalDatasetLabels
  }
}
</script>

<style scoped>

</style>
